import { useEffect, useState } from "react";
import DataTable from "../../component/DataTable";
import { Link } from "react-router-dom";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import AddTags from "./AddTags";
import EditTags from "./EditTags";
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";

const tagListEndpoint = ApiEndpoints.tags.tagList;
const tagDeleteEndpoint = ApiEndpoints.tags.tagDelete;
const tableHeader = ["Date","Name", "Status"];
const tbody = ["createdAt","name", "status"];

export default function Tags() {
  const [tagId, setTagId] = useState("");
  const [modaleditShow, setModalEditShow] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [data, setData] = useState([]);

  const dataFetch = async () => {
    try {
      const response = await ApiRequest("GET", tagListEndpoint);
      const result = response.tags;
      setData(result);
    } catch (error) {
      console.error("Error fetching tags:", error);
    }
  };

  useEffect(() => {
    dataFetch();
  }, []);

  const handleDelete = async (tag_id) => {
      const payload = { tag_id };
      try {
        const response = await ApiRequest("POST", tagDeleteEndpoint, payload);
        toast.success(response.message);
        dataFetch();
      } catch (error) {
        console.error("Error deleting tag:", error);
      }
    };

    const pagename = {
      name: 'Blog Management',
      user: 'Admin',
      innerpage: 'Blog Management / Tag'
    }

  return (
    <>
    <AdminHeader pagename={pagename}/>

      <div className="add-btn-section">
        <Link className="admin-add-btn" onClick={() => setModalShow(true)}>Add +</Link>
        <DataTable
          data={data}
          tableHeader={tableHeader}
          tbody={tbody}
          setModalShow={setModalEditShow}
          setId = {setTagId}
          // onDelete={handleDelete}
        />
      </div>
      <AddTags show={modalShow} onHide={() => setModalShow(false)}/>
      <EditTags show={modaleditShow} tagId ={tagId} onHide={() => setModalEditShow(false)}/>
    </>
  );
}
